<!-- 
DecreeZoneList.vue
功能：法令專區List
作者：i9400538 陳博承
完成：2022-06-01
-->
<template>
  <div>
    <div>法令專區</div>
    <div v-for="(item, index) in itemList" :key="`preci-${index}`">
      <h4 class="text-green mb-4-5 mt-4-5">
        <span class="text">{{ item.subName }} ({{ item.child && item.child.length }})</span>
      </h4>
      <div class="row">
        <div class="col-3" v-for="(child, index) in item.child" :key="`preci-child-${index}`">
          <div
            @click="selectTable(child.ser_no)"
            class="flex-column btn btn-border-green font-weight-bold m-0 mb-4-5 w-100 d-flex align-items-center align-self-center justify-content-center"
            style="height:85px"
          >
            <div class="w-100">{{ child.category_name }}</div>
            <div
              v-if="child.cust_list.length == 0"
              class="w-100 font-size-13 font-weight-normal mb-1"
            ></div>
            <div
              v-else
              class="w-100 font-size-13 font-weight-normal mb-1"
            >{{ setName(child.cust_list) }}...</div>
            <div
              class="w-100 font-size-13 font-weight-normal"
            >({{ child.cust_count ? child.cust_count : '0' }})</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 打開遮罩 -->
    <mxMask :open="mxMaskOpen" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { commonMixin } from "@/mixins/common";
import { getCategoryInfo, setListAreaLog } from "@/service";
import mxMask from "@/desktop/components/mxMask";

export default {
  name: "DecreeZoneList",
  mixins: [commonMixin],
  components: {
    mxMask
  },
  props: {
    status: String
  },
  computed: {
    ...mapGetters(["GetCategoryStatus"])
  },
  data() {
    //data block layout
    return {
      itemList: [],
      mxMaskOpen: false
    };
  },
  methods: {
    ...mapActions(["setListAreaSerNo"]),
    setName(ary) {
      // 格式化客戶名單
      return ary.join("、").slice(0, 11);
    },
    initDecreeZone() {
      // 初始化
      this.panelOpen("mxMaskOpen"); //開啟遮罩
      getCategoryInfo(this.$store.state.userInfo.id, "法令專區").then(
        result => {
          this.panelClose("mxMaskOpen"); //關閉遮罩
          if (result.header && result.header.status == "200") {
            // 若是在Box內開啟，回傳功能清單給Box
            if (this.$store.state.userInfo.userType === "box") {
              this.sendCategoryInfoToBox(result.body);
            }
            // 分類中類項目資料
            let datalist = new Set(
              result.body.map(item => {
                return item.subcategory;
              })
            );
            this.itemList = [];
            datalist.forEach(item => {
              this.itemList.push({ subName: item, child: [] });
            });
            result.body.forEach(sItem => {
              this.itemList.forEach(mItem => {
                if (sItem.subcategory == mItem.subName) {
                  mItem.child.push(sItem);
                }
              });
            });
            //各中類依名稱排序欄位做排序(小->大)
            this.itemList.forEach(s => {
              s.child.sort(function(a, b) {
                return a.category_name_order - b.category_name_order;
              });
            });
            this.registerHanlink(); // for hard word
          }
        }
      );
    },
    selectTable(serNo) {
      // 開啟指定類型 Table 畫面
      let sendStatus = this.GetCategoryStatus[serNo];
      this.setListAreaSerNo(serNo); //  更新流水編到 Vuex
      if (sendStatus) {
        this.setLog(serNo); //新增名單專區Log
        this.$emit("change-status", sendStatus);
      }
    },
    setLog(serNo) {
      setListAreaLog(this.$store.state.userInfo.id, serNo, "1").then(result => {
        if (result.header && result.header.status == "200") {
          console.log("新增成功");
        } else {
          console.error("新增名單專區log API 錯誤");
        }
      });
    },
    sendCategoryInfoToBox(data) {
      //回傳功能清單給Box
      this.$nextTick(() => {
        if (window.webkit) {
          let list = data.map(item => {
            return {
              List_Name: item.category_name,
              List_SerNo: item.ser_no
            };
          });
          let categoryObj = {
            Category_List: list,
            Category_Name: "法令專區"
          };
          window.webkit.messageHandlers.sendCategoryList.postMessage(
            JSON.stringify(categoryObj)
          );
        }
      });
    }
  },
  mounted() {
    // 初始化
    this.initDecreeZone();
  }
};
</script>
